import { forceAssert } from '../../common-functions';
import type { JsonData, JsonDataItem } from '../../generic-types';
import { VisibilityConditionBase } from './visibility-condition-base';
import type { VisibilityCondition } from './visibility-condition.interfaces';

export interface QuestionnaireValueItem {
  id: number; //answer id (only available for textual questionnaire)
  questionId: number;
  files?: Array<JsonData>;
  images?: Array<string>;
  linkedRecordIds?: Array<string>;
  observations?: string;
  questionPosition?: number;
  numericAnswer?: number; // only available for numeric questionnaire
}

export class QuestionnaireVisibilityCondition extends VisibilityConditionBase {
  constructor(fieldCondition: VisibilityCondition) {
    super(fieldCondition);
  }

  public runVisibilityCondition(currentData: JsonDataItem): boolean {
    let isHidden = this.defaultIsHidden;

    if (this.fieldCondition.sourceFieldId) {
      const questionnaireData = forceAssert<Record<string, QuestionnaireValueItem>>(
        currentData[this.fieldCondition.sourceFieldId]
      )?.['value'];

      if (Array.isArray(questionnaireData)) {
        if (questionnaireData.length === 0 && this.fieldCondition.negation) {
          isHidden = false;
        } else {
          const question = questionnaireData.find(
            (item) => item.questionId === Number(this.fieldCondition.sourceSubField)
          );

          if (question) {
            let dataValue, visibilityValue;

            if ('ENTITY_ID' === this.fieldCondition.targetValueType && this.fieldCondition.targetValueId) {
              // TEXTUAL_QUESTIONNAIRE
              dataValue = question.id;
              visibilityValue = this.fieldCondition.targetValueId;
            } else if ('NUMBER' === this.fieldCondition.targetValueType && this.fieldCondition.targetValue) {
              // NUMERIC_QUESTIONNAIRE
              dataValue = question.numericAnswer;
              visibilityValue = Number(this.fieldCondition.targetValue);
            }

            isHidden = this.determineIsHidden(dataValue, visibilityValue, this.fieldCondition.negation);
          } else {
            isHidden = this.fieldCondition.negation !== true;
          }
        }
      }
      //The question has not yet been answered, in a new record
      else if (!questionnaireData && this.fieldCondition.negation) {
        isHidden = false;
      }
    }

    return isHidden;
  }
}
